import React from "react";
import Certificate from "./Certificate";
import Products from "./Products";
import History from "./History";
import videoBG from "../assets/mp4/cert.mp4";

const CertificateProductsHistory = () => (
  <section className="central-section">
      <video autoPlay loop muted playsInline className="background-video">
          <source src={videoBG} type="video/mp4" />
          Seu navegador não suporta a tag de vídeo.
      </video>
    <Certificate />
    <Products />
    <History />
  </section>
);

export default CertificateProductsHistory;
